const COLOR_LIST = [
    {
        id: 'primary_blue',
        color: '#1377C4',
    },
    {
        id: 'secondary_red',
        color: '#DB3B5D',
    },
    {
        id: 'bigdata_orange',
        color: '#FF9300',
    },
    {
        id: 'primary_black',
        color: '#21242E',
    },
    {
        id: 'secondary_green',
        color: '#20D373',
    },
];

export interface BodyCompInfo {
    id: string;
    decimalPlace: number;
    unit: string;
    koreanName: string;
    englishName: string;
    color: string;
}

export const BODYCOMP_INFO_LIST: BodyCompInfo[] = [
    {
        id: 'WT',
        decimalPlace: 1,
        unit: 'kg',
        koreanName: '체중',
        englishName: 'Weight',
        color: COLOR_LIST.find(item => item.id === 'primary_blue')?.color || '',
    },
    {
        id: 'BMI',
        decimalPlace: 1,
        unit: 'kg/m²',
        koreanName: 'BMI',
        englishName: 'Body Mass Index',
        color: COLOR_LIST.find(item => item.id === 'primary_blue')?.color || '',
    },
    {
        id: 'SMM',
        decimalPlace: 1,
        unit: 'kg',
        koreanName: '골격근량',
        englishName: 'Skeletal Muscle Mass',
        color: COLOR_LIST.find(item => item.id === 'secondary_red')?.color || '',
    },
    {
        id: 'SLM',
        decimalPlace: 1,
        unit: 'kg',
        koreanName: '근육량',
        englishName: 'Soft Lean Mass',
        color: COLOR_LIST.find(item => item.id === 'secondary_red')?.color || '',
    },
    {
        id: 'BMR',
        decimalPlace: 0,
        unit: 'kcal',
        koreanName: '기초대사량',
        englishName: 'Basal Metabolic Rate',
        color: COLOR_LIST.find(item => item.id === 'secondary_red')?.color || '',
    },
    {
        id: 'PBF',
        decimalPlace: 1,
        unit: '%',
        koreanName: '체지방률',
        englishName: 'Percent Body Fat',
        color: COLOR_LIST.find(item => item.id === 'bigdata_orange')?.color || '',
    },
    {
        id: 'BFM',
        decimalPlace: 1,
        unit: 'kg',
        koreanName: '체지방량',
        englishName: 'Body Fat Mass',
        color: COLOR_LIST.find(item => item.id === 'bigdata_orange')?.color || '',
    },
    {
        id: 'VFL',
        decimalPlace: 0,
        unit: 'Lv',
        koreanName: '내장지방레벨',
        englishName: 'Visceral Fat Level',
        color: COLOR_LIST.find(item => item.id === 'bigdata_orange')?.color || '',
    },
    {
        id: 'WHR',
        decimalPlace: 2,
        unit: '',
        koreanName: '복부지방률',
        englishName: 'Waist Hip Ratio',
        color: COLOR_LIST.find(item => item.id === 'bigdata_orange')?.color || '',
    },
    {
        id: 'HT',
        decimalPlace: 1,
        unit: 'cm',
        koreanName: '신장',
        englishName: 'Height',
        color: COLOR_LIST.find(item => item.id === 'primary_blue')?.color || '',
    },
    {
        id: 'FitScore',
        decimalPlace: 0,
        unit: '점',
        koreanName: '핏스코어',
        englishName: 'Fitscore',
        color: COLOR_LIST.find(item => item.id === 'primary_black')?.color || '',
    },
    {
        id: 'AverageTime',
        decimalPlace: 0, // 임의로 0으로 설정
        unit: '회/월',
        koreanName: '검사패턴',
        englishName: 'Average Time',
        color: COLOR_LIST.find(item => item.id === 'secondary_green')?.color || '',
    },
];

export const BODYTYPE_COLOR_LIST = [
    {
        bodyTypeCode: 'Muscle',
        bodyTypeKoreanName: '근육형',
        color: '#148EED',
        className: 'cluster-blue',
    },
    {
        bodyTypeCode: 'Slender_2040',
        bodyTypeKoreanName: '날씬형',
        color: '#6C4AE2',
        className: 'cluster-purple',
    },
    {
        bodyTypeCode: 'Fit',
        bodyTypeKoreanName: '탄탄형',
        color: '#6C4AE2',
        className: 'cluster-purple',
    },
    {
        bodyTypeCode: 'Common',
        bodyTypeKoreanName: '보통형',
        color: '#7EE15F',
        className: 'cluster-yellowGreen',
    },
    {
        bodyTypeCode: 'Average',
        bodyTypeKoreanName: '평균형',
        color: '#7EE15F',
        className: 'cluster-yellowGreen',
    },
    {
        bodyTypeCode: 'Health',
        bodyTypeKoreanName: '건강형',
        color: '#20D373',
        className: 'cluster-green',
    },
    {
        bodyTypeCode: 'Bulk',
        bodyTypeKoreanName: '건장형',
        color: '#29B269',
        className: 'cluster-darkGreen',
    },
    {
        bodyTypeCode: 'Leanobesity',
        bodyTypeKoreanName: '마른비만형',
        color: '#FFA600',
        className: 'cluster-yellow',
    },
    {
        bodyTypeCode: 'Lightobesity',
        bodyTypeKoreanName: '경도비만형',
        color: '#F77A0C',
        className: 'cluster-orange',
    },
    {
        bodyTypeCode: 'Obesity',
        bodyTypeKoreanName: '비만형',
        color: '#83582C',
        className: 'cluster-brown',
    },
    {
        bodyTypeCode: 'Heavyobesity',
        bodyTypeKoreanName: '고도비만형',
        color: '#925D28',
        className: 'cluster-darkBrown',
    },
    {
        bodyTypeCode: 'Slender_5060',
        bodyTypeKoreanName: '날씬형',
        color: '#E96095',
        className: 'cluster-pink',
    },
    {
        bodyTypeCode: 'Sarcopenia',
        bodyTypeKoreanName: '저근육형',
        color: '#CD30A1',
        className: 'cluster-wine',
    },
    {
        bodyTypeCode: 'Warning',
        bodyTypeKoreanName: '위험형',
        color: '#EE3059',
        className: 'cluster-red',
    },
];
